import type { UsuarioPerfil } from "@/types";
import { supabase } from "@/lib/supabase";

export const authService = {
  signIn(email: string, password: string) {
    return supabase.auth.signInWithPassword({ email, password });
  },

  signInWithGoogle() {
    return supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: window.location.origin },
    });
  },

  signOut() {
    return supabase.auth.signOut();
  },

  sendPasswordReset(email: string) {
    return supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/redefinir-senha`,
    });
  },

  updatePassword(password: string) {
    return supabase.auth.updateUser({ password });
  },

  async getUserProfile(authUserId: string): Promise<UsuarioPerfil | null> {
    const { data, error } = await supabase
      .from("usuarios")
      .select("id, auth_user_id, nome, email, avatar_url, ativo, perfil_id, filial_id, perfil:perfis(id, nome, descricao)")
      .eq("auth_user_id", authUserId)
      .maybeSingle();

    if (error) throw error;
    return data as unknown as UsuarioPerfil | null;
  },
};
